import React, { useState, useEffect } from "react";
import { Table, Button, Select, Popconfirm, Input, Switch, message } from "antd";
import api from "../services/api";

const { Option } = Select;

const Sources = () => {
  const [sources, setSources] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedSource, setSelectedSource] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [editingValue, setEditingValue] = useState("");
  const user = localStorage.getItem("user");

  useEffect(() => {
    getSources();
    getDistinct();
  }, []);

  useEffect(() => {
    if (selectedSource) {
      getOneSource(selectedSource);
    } else {
      getSources();
    }
  }, [selectedSource]);

  const getSources = async () => {
    try {
      const res = await api.get("/sources/", { headers: { user } });
      setSources(res.data.sources);
    } catch (err) {
      console.error("خطا در دریافت منابع:", err);
    }
  };

  const getDistinct = async () => {
    try {
      const res = await api.get("/sources/distinct", { headers: { user } });
      setDropdownOptions(res.data.sources);
    } catch (err) {
      console.error("خطا در دریافت منابع:", err);
    }
  };

  const getOneSource = async (name) => {
    try {
      const res = await api.get(`/sources/${encodeURIComponent(name)}`, {
        headers: { user },
      });
      setSources(res.data.sources);
    } catch (err) {
      console.error("خطا در دریافت منبع:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/sources/${id}`, { headers: { user } });
      setSources((prev) => prev.filter((s) => s._id !== id));
      message.success("منبع حذف شد");
    } catch (err) {
      console.error("خطا در حذف:", err);
      message.error("خطا در حذف منبع");
    }
  };

  const handleEdit = async (id, field, value) => {
    try {
      const res = await api.put(
        `/sources/${id}`,
        { [field]: value },
        { headers: { user } }
      );
      if (res.status === 200) {
        setSources((prev) =>
          prev.map((src) => (src._id === id ? { ...src, [field]: value } : src))
        );
        message.success("ویرایش با موفقیت انجام شد");
      }
    } catch (err) {
      console.error("خطا در ویرایش:", err);
      message.error("خطا در ویرایش");
    }
  };

  const toggleSourceStatus = async (id, currentStatus) => {
    try {
      const res = await api.put(
        "/sources/toggle-status",
        { id, enable: !currentStatus },
        { headers: { user } }
      );
      if (res.status === 200) {
        setSources((prev) =>
          prev.map((src) =>
            src._id === id ? { ...src, enable: res.data.enable } : src
          )
        );
        message.info(`وضعیت تغییر یافت: ${res.data.enable ? "فعال" : "غیرفعال"}`);
      }
    } catch (err) {
      console.error("خطا در تغییر وضعیت:", err);
      message.error("خطا در تغییر وضعیت");
    }
  };

  const startEditing = (id, field, value) => {
    let editableValue = "";
    if (Array.isArray(value)) {
      editableValue = value.join(", ");
    } else if (value !== null && value !== undefined) {
      editableValue = value;
    }
    setEditingId(id);
    setEditingField(field);
    setEditingValue(editableValue);
  };
  

  const saveEditing = () => {
    if (editingId && editingField !== null) {
      let valueToSave = editingValue;
  
      if (editingField === "removeTags") {
        // اگر editingValue آرایه یا null بود، اول به رشته تبدیل کن
        const strValue = Array.isArray(editingValue)
          ? editingValue.join(", ")
          : editingValue || "";
        valueToSave = strValue.split(",").map((v) => v.trim());
      }
  
      handleEdit(editingId, editingField, valueToSave);
    }
  
    setEditingId(null);
    setEditingField(null);
    setEditingValue("");
  };
  

  const renderEditableCell = (text, record, field, type = "text") => {
    // مقدار پیش‌فرض برای آرایه‌ها
    let displayValue = text;
    if (Array.isArray(text) && text.length && typeof text[0] === "object") {
      displayValue = text
        .map((it) => `${it.selector ?? ""}:${it.attr ?? ""}`)
        .join(" | ");
    }
    // اگر آرایه ساده باشه -> به صورت join
    else if (Array.isArray(text)) {
      displayValue = text.length ? text.join(", ") : ""; // اگر آرایه خالی است، رشته خالی
    }
    if (editingId === record._id && editingField === field) {
      if (type === "boolean") {
        return (
          <Switch
            checked={editingValue}
            onChange={(val) => setEditingValue(val)}
            onBlur={saveEditing}
            autoFocus
          />
        );
      } else {
        return (
          <Input
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onPressEnter={saveEditing}
            onBlur={saveEditing}
            autoFocus
          />
        );
      }
    } else {
      if (type === "boolean") {
        return (
          <div
            style={{ cursor: "pointer" }}
            onClick={() => startEditing(record._id, field, record[field])}
          >
            {record[field] ? "✔️" : "❌"}
          </div>
        );
      } else {
        return (
          <div
            style={{ cursor: "pointer", minHeight: 20  }}
            onClick={() => startEditing(record._id, field, record[field] ?? "" )}
          >
            {displayValue || "—"}
            {/* {Array.isArray(text) ? text.join(", ") : text || "—"} */}
          </div>
        );
      }
    }
  };

  const columns = [
    {
      title: "عملیات",
      dataIndex: "_id",
      render: (id) => (
        <Popconfirm
          title="حذف منبع؟"
          onConfirm={() => handleDelete(id)}
          okText="بله"
          cancelText="خیر"
        >
          <Button danger size="small">
            حذف
          </Button>
        </Popconfirm>
      ),
    },
    { title: "sourceName",   dataIndex: "sourceName", render: (t, r) => renderEditableCell(t, r, "sourceName") },
    { title: "enable",       dataIndex: "enable", render: (t, r) => <Switch checked={t} onChange={() => toggleSourceStatus(r._id, t)} /> },
    { title: "rssURL",       dataIndex: "rssURL", render: (t, r) => renderEditableCell(t, r, "rssURL") },
    { title: "isCategorized", dataIndex: "isCategorized", render: (t, r) => renderEditableCell(t, r, "isCategorized", "boolean") },
    { title: "category",     dataIndex: "category", render: (t, r) => renderEditableCell(t, r, "category") },
    { title: "subCategory",  dataIndex: "subCategory", render: (t, r) => renderEditableCell(t, r, "subCategory") },
    { title: "tagClassName", dataIndex: "tagClassName", render: (t, r) => renderEditableCell(t, r, "tagClassName") },
    { title: "cutAfter",     dataIndex: "cutAfter", render: (t, r) => renderEditableCell(t, r, "cutAfter") },
    { title: "removeTags",   dataIndex: "removeTags", render: (t, r) => renderEditableCell(t, r, "removeTags") },
    { title: "removeAttrs",  dataIndex: "removeAttrs", render: (t, r) => renderEditableCell(t, r, "removeAttrs") },
    { title: "secondTag",    dataIndex: "secondTag", render: (t, r) => renderEditableCell(t, r, "secondTag") },
    { title: "isLocalImg",   dataIndex: "isLocalImg", render: (t, r) => renderEditableCell(t, r, "isLocalImg", "boolean") },
    { title: "siteAddress",  dataIndex: "siteAddress", render: (t, r) => renderEditableCell(t, r, "siteAddress") },
    { title: "sourceNameEn", dataIndex: "sourceNameEn", render: (t, r) => renderEditableCell(t, r, "sourceNameEn") },
    {
      title: "lastTimeFetch",
      dataIndex: "lastTimeFetch",
      render: (value) => {
        if (!value) return "-";

        return new Date(value).toLocaleString("fa-IR", {
          timeZone: "Asia/Tehran",
          dateStyle: "short",
          timeStyle: "medium",
        });
      },
    },
    { title: "status",        dataIndex: "status", render: (t, r) => renderEditableCell(t, r, "status") },
    { title: "ID",            dataIndex: "_id" },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <label style={{ marginRight: 8 }}>انتخاب منبع:</label>
        <Select
          style={{ width: 200 }}
          value={selectedSource}
          onChange={setSelectedSource}
          allowClear
        >
          {dropdownOptions.map((name, idx) => (
            <Option key={idx} value={name}>
              {name}
            </Option>
          ))}
        </Select>
      </div>
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={sources}
        scroll={{ x: true }}
        pagination={{ pageSize: 15 }}
      />
    </div>
  );
};

export default Sources;
